import { getArrayRemove, getArrayUnion, getFirestore } from '../../system/firebase';

import { ELASTICSEARCH_PAGE_SIZE, ELASTICSEARCH_TYPE_CITY, ELASTICSEARCH_TYPE_COUNTRY, ELASTICSEARCH_TYPE_STATE, mapJobsDataFromElasticSearchJson } from '../elasticSearchHelper';
import {
    SNACK_BAR_MESSAGE_OPERATION_FAILED,
    JOB_APPLY_SUCCESS,
    ADD_BOOKMARK_JOB_SUCCESS,
    REMOVE_BOOKMARK_JOB_SUCCESS,
    FILTER_DATE_POST_WITHIN_DAYS,
    PAY_FREQUENCY_LIST_HOURLY,
    PAY_FREQUENCY_LIST_WEEKLY,
    PAY_FREQUENCY_LIST_MONTHLY,
    PAY_FREQUENCY_LIST_YEARLY,
    PAY_FREQUENCY_LIST_DAILY,
    PAY_FREQUENCY_LIST_BI_WEEKLY,
    PAY_FREQUENCY_LIST_PER_JOB,
} from '../constants';
import { convertFirebaseTimestampsToDate } from '../dateHelper';
import { mapDefinedFields } from '../dtoHelper';
import { checkEsToken, elasticSearchJobSearchPostFetch, elasticSearchJobTitleSkillSetSuggestionSearchPostFetch, getElasticSearchLocationSuggestionPostFetch } from './appServices';
import { nanoid } from '../../common/nanoidHelper';

import _get from 'lodash/get';
import _set from 'lodash/set';
import _map from 'lodash/map';
import _pick from 'lodash/pick';
import _omit from 'lodash/omit';

// import { getTime, startOfDay, subDays } from 'date-fns';

export const convertApplicantsFirebaseTimestampsToDate = (list = []) => {
    return _map(list, data => convertFirebaseTimestampsToDate(data, ['applyDt']));
};

// export const fetchJobs = async (set, sort = 'date') => {
//     const db = getFirestore();
//     const activeJobsQuery = db
//         .collection('jobs')
//         .where('active', '==', true)
//         .orderBy('createDt', sort === 'date' ? 'desc' : 'asc');
//     const querySnapshot = await activeJobsQuery.get();
//     const jobs = [];

//     querySnapshot.forEach(doc => {
//         let data = doc.data();
//         data = convertFirebaseTimestampsToDate(data, ['createDt', 'updateDt']);
//         jobs.push({ ...data, applicants: convertApplicantsFirebaseTimestampsToDate(_get(data, 'applicants')), uid: doc.id });
//     });

//     set(jobs);
// };

//--------------------------------------------------------------------------
// Search JOB
// queryObject elements:
// {
//     datePost: 0,
//     employerId: 'string',
//     id: 'string',
//     jobTitle: 'string',
//     jobType: ['string'],
//     location: {
//         value: {
//             city: 'string',
//             country: 'string',
//             type: 'string',
//             location: {
//                 lat: 0,
//                 lon: 0,
//             },
//             name: 'string',
//             state: 'string',
//         },
//     },
//     payFrequency: 'string',
//     rateDailyMax: 0,
//     rateMax: 0,
//     rateMin: 0,
//     rateYearlyMax: 0,
//     salaryRate: {
//         payFrequency: 'string',
//         rateMin: 0,
//     },
//     showOnly: true,
//     sortTag: {
//         sortColumn: 'ACTIVE_DATE',
//         sortOrder: 'ASC',
//     },
//     workFromHome: 'string',
// };
export const fetchJobs = async ({ from = 0, size = ELASTICSEARCH_PAGE_SIZE, queryObject, esToken, setEsToken } = {}) => {
    // const db = getFirestore();

    // format the search criteria queryObject
    const datePost = _get(queryObject, 'datePost');
    const withinNumberOfDays = FILTER_DATE_POST_WITHIN_DAYS[datePost];
    const jobTypeList = _get(queryObject, 'jobType', []);
    const salaryRate = _get(queryObject, 'salaryRate'); // salaryRate is an object { rateMin, payFrequency }
    const rateMin = _get(salaryRate, 'rateMin', 0); // rateMin will be ignored if payFrequency is not selected
    const payFrequency = _get(salaryRate, 'payFrequency');
    const showOnly = _get(salaryRate, 'showOnly');
    let salaryRateDto = null;
    switch (payFrequency) {
        case PAY_FREQUENCY_LIST_HOURLY: {
            salaryRateDto = { rateYearlyMax: rateMin * 2080 };
            break;
        }
        case PAY_FREQUENCY_LIST_WEEKLY: {
            salaryRateDto = { rateYearlyMax: rateMin * 52 };
            break;
        }
        case PAY_FREQUENCY_LIST_BI_WEEKLY: {
            salaryRateDto = { rateYearlyMax: rateMin * 26 };
            break;
        }
        case PAY_FREQUENCY_LIST_MONTHLY: {
            salaryRateDto = { rateYearlyMax: rateMin * 12 };
            break;
        }
        case PAY_FREQUENCY_LIST_YEARLY: {
            salaryRateDto = { rateYearlyMax: rateMin };
            break;
        }
        case PAY_FREQUENCY_LIST_DAILY: {
            salaryRateDto = { rateDailyMax: rateMin };
            break;
        }
        case PAY_FREQUENCY_LIST_PER_JOB: {
            salaryRateDto = { ratePerJobMax: rateMin };
            break;
        }
        default:
        // do nothing
    }
    showOnly && _set(salaryRateDto, 'payFrequency', payFrequency);
    const location = _get(queryObject, 'location.value'); // location is a label-value pair from suggestion
    const locationType = _get(location, 'type');
    let locationQueryObject = {};
    switch (locationType) {
        case ELASTICSEARCH_TYPE_COUNTRY: {
            locationQueryObject = {
                country: _get(location, 'name'),
            };
            break;
        }
        case ELASTICSEARCH_TYPE_STATE: {
            locationQueryObject = {
                country: _get(location, 'country'),
                state: _get(location, 'name'),
            };
            break;
        }
        case ELASTICSEARCH_TYPE_CITY: {
            const cityLocationLatitude = _get(location, 'location.lat');
            const cityLocationLongitude = _get(location, 'location.lon');
            if (cityLocationLatitude && cityLocationLongitude) {
                _set(locationQueryObject, 'location', _get(location, 'location'));
            } else {
                // if no lat/long, match city name
                _set(locationQueryObject, 'city', _get(location, 'name'));
                _set(locationQueryObject, 'state', _get(location, 'state'));
                _set(locationQueryObject, 'country', _get(location, 'country'));
            }
            break;
        }
        default:
        // do nothing
    }
    const sortDto = queryObject?.sortTag || undefined;

    // Create the actual queryObject for ElasticSearch
    const mappedQueryObject = mapDefinedFields({
        jobTitle: queryObject?.jobTitle || undefined,
        // searchKeywordList: queryObject?.jobTitle
        //     ? [
        //           'React Developer',
        //           'JavaScript Developer',
        //           // 'Front End Developer',
        //           'Web Developer',
        //           'UI Developer',
        //           'UX Developer',
        //           'HTML',
        //           'CSS',
        //           'JavaScript',
        //           'Figma',
        //           'Web Design',
        //           'User Interface',
        //           'User Experience',
        //           'Responsive Design',
        //           'Web Application Development',
        //           'Software Development',
        //           'Programming',
        //           'Front End Development',
        //           'Web Technologies',
        //           'Visual Design',
        //           'Java',
        //           'Software Engineer',
        //           'Full Stack Developer',
        //           'Web Application',
        //           'User Interface Design',
        //           'User Experience Design',
        //           'Web Development Tools',
        //           'Interactive Design',
        //           'Design Thinking',
        //           'Developer',
        //           'Scrum',
        //       ]
        //     : [],
        ...locationQueryObject,
        activeDt: withinNumberOfDays || undefined,
        employmentType: jobTypeList.length > 0 ? jobTypeList : undefined,
        isTelework: queryObject?.workFromHome || undefined,
        intern: queryObject?.internPositions || undefined,
        ...salaryRateDto,
        ...sortDto,
        id: queryObject?.id || undefined,
        employerId: queryObject?.employerId || undefined,
        active: true,
    });

    // console.log('==========> ', { mappedQueryObject });

    let checkedEsToken = null;
    try {
        checkedEsToken = await checkEsToken(esToken);

        if (checkedEsToken) {
            const searchResult = await elasticSearchJobSearchPostFetch({ queryObject: { ...mappedQueryObject, from, size }, token: checkedEsToken.token });
            // console.log('==========> searchResult', { searchResult });

            if (_get(searchResult, 'success')) {
                const total = _get(searchResult, 'total', 0);
                const result = _get(searchResult, 'result', []);
                const mappedList = _map(result, jobItem => {
                    return mapJobsDataFromElasticSearchJson(jobItem);
                });
                return { total, list: mappedList };
            } else {
                console.error('Failed to search jobs');
            }

            if (checkedEsToken.isNew) {
                setEsToken(_omit(checkedEsToken, 'isNew'));
            }
        }
    } catch (error) {
        console.error('Failed checking token', error);
    }

    return { total: 0, list: [] };
};

export const loadJobs = ({ setJobs } = {}) => {
    const db = getFirestore();

    // const currentMonthIdx = getMonth(_get(calendarData, 'w1d0.dt'));
    // const firstDayOf6thWeek = _get(calendarData, 'w5d0.dt');
    // const has6Weeks = currentMonthIdx === getMonth(firstDayOf6thWeek);
    // const endDtPath = has6Weeks ? 'w5d6.dt' : 'w4d6.dt';

    // const startDt = _get(calendarData, 'w0d0.dt', startOfMonth(new Date()));
    // const endDt = _get(calendarData, endDtPath, endOfMonth(new Date()));

    const jobsRef = db.collection('jobs').where('active', '==', true);

    return jobsRef.onSnapshot(querySnapshot => {
        const jobList = _map(querySnapshot.docs, doc => {
            const data = doc.data();
            // const startDt = _get(data, 'startDt');
            // const startDtStartOfDay = startDt ? startOfDay(startDt.toDate()) : null;
            // const dayId = _findKey(calendarData, item => isEqualDate(_get(item, 'dt'), startDtStartOfDay));
            // return { interviewId: doc.id, dayId, ...data };

            const dto = convertFirebaseTimestampsToDate(data, ['statusDt', 'updateDt', 'activeDt', 'createDt', 'inactiveDt']);

            return { ...dto, uid: doc.id };
        });

        // console.log('loadJobs', JSON.stringify({ jobList }));
        setJobs(jobList);
    });
};

//=====================================================================================
// TODO TEMP remove service to get all active jobs for the Emp Brand Page -el 20220211
// TODO TEMP remove service to get all active jobs for the Emp Brand Page -el 20220211
// TODO TEMP remove service to get all active jobs for the Emp Brand Page -el 20220211
// TODO TEMP remove service to get all active jobs for the Emp Brand Page -el 20220211
// TODO TEMP remove service to get all active jobs for the Emp Brand Page -el 20220211
//=====================================================================================
export const fetchBrandPageJobs = async ({ /* employerId, */ esToken, setEsToken } = {}) => {
    // const db = getFirestore();

    let checkedEsToken = null;
    try {
        checkedEsToken = await checkEsToken(esToken);

        if (checkedEsToken) {
            const searchResult = await elasticSearchJobSearchPostFetch({ queryObject: { from: 1, size: 9999 }, token: checkedEsToken.token });

            if (_get(searchResult, 'success')) {
                const total = _get(searchResult, 'total', 0);
                const result = _get(searchResult, 'result', []);
                const mappedList = _map(result, jobItem => {
                    return mapJobsDataFromElasticSearchJson(jobItem);
                });
                return { total, list: mappedList };
            } else {
                console.error('Failed to search jobs');
            }

            if (checkedEsToken.isNew) {
                setEsToken(_omit(checkedEsToken, 'isNew'));
            }
        }
    } catch (error) {
        console.error('Failed checking token', error);
    }

    return { total: 0, list: [] };
};

export const fetchJobById = async (jobId, set /*, sort = 'date' */) => {
    const db = getFirestore();
    const jobRef = db.collection('jobs').doc(jobId);
    const doc = await jobRef.get();

    let data = doc.data();
    data = convertFirebaseTimestampsToDate(data, ['createDt', 'updateDt']);
    const job = { ...data, applicants: convertApplicantsFirebaseTimestampsToDate(_get(data, 'applicants')), uid: doc.id };

    set([job]);
};

export const fetchJobsByEmployerId = async ({ employerId, setData, sortTag = 'date' }) => {
    const db = getFirestore();
    const activeJobsQuery = db
        .collection('jobs')
        .where('active', '==', true)
        .where('employerId', '==', employerId)
        .orderBy('createDt', sortTag === 'date' ? 'desc' : 'asc');
    const querySnapshot = await activeJobsQuery.get();
    const jobs = [];

    querySnapshot.forEach(doc => {
        let data = doc.data();
        data = convertFirebaseTimestampsToDate(data, ['createDt', 'updateDt']);
        jobs.push({ ...data, applicants: convertApplicantsFirebaseTimestampsToDate(_get(data, 'applicants')), uid: doc.id });
    });

    setData(jobs);
};

export const applyJob = async ({ userId, jsName, jsCountry, jobId, employerId, callback, setSnackbarMessage, setSnackbarErrorMessage }) => {
    const db = getFirestore();
    const now = new Date();

    //-------------------------------------------------------------------------------------------
    // prep for jobs
    //-------------------------------------------------------------------------------------------
    const jobRef = db.collection('jobs').doc(jobId);

    //-------------------------------------------------------------------------------------------
    // prep for users
    //-------------------------------------------------------------------------------------------
    const userRef = db.collection('users').doc(userId);
    const userDto = { appliedJobs: { [jobId]: now } };

    //-------------------------------------------------------------------------------------------
    // prep for employers
    //-------------------------------------------------------------------------------------------
    const employerRef = db.collection('employers').doc(employerId);

    //-------------------------------------------------------------------------------------------
    // prep for appliedJobs
    //-------------------------------------------------------------------------------------------
    const appliedJobRef = db.collection('appliedJobs').doc(nanoid());
    const appliedJobDto = {
        userId,
        jobId,
        employerId,
        jsName,
        jsCountry,
        createDt: new Date(),
    };

    //-------------------------------------------------------------------------------------------
    // start batch writes
    //-------------------------------------------------------------------------------------------
    try {
        // const batch = db.batch();

        await db.runTransaction(async transaction => {
            //-------------------------------------------------------------------------------------------
            // read jobs
            //-------------------------------------------------------------------------------------------
            const jobDoc = await transaction.get(jobRef);
            if (jobDoc.exists) {
                const jobData = jobDoc.data();
                _set(appliedJobDto, 'jobTitle', jobData.jobTitle);
            }

            //-------------------------------------------------------------------------------------------
            // read employers
            //-------------------------------------------------------------------------------------------
            const employerDoc = await transaction.get(employerRef);
            if (employerDoc.exists) {
                const employerData = employerDoc.data();
                _set(appliedJobDto, 'companyName', employerData.companyName);
            }

            //-------------------------------------------------------------------------------------------
            // write users
            //-------------------------------------------------------------------------------------------
            await transaction.set(userRef, userDto, { merge: true });

            //-------------------------------------------------------------------------------------------
            // write appliedJobs
            //-------------------------------------------------------------------------------------------
            await transaction.set(appliedJobRef, mapDefinedFields(appliedJobDto));
        });

        callback && callback();

        setSnackbarMessage(JOB_APPLY_SUCCESS);

        return true;
    } catch (error) {
        console.log('error', error);
        setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        return false;
    }
};

export const bookmarkJob = async ({ isAdd, userId, jobId, setSnackbarMessage, setSnackbarErrorMessage }) => {
    const db = getFirestore();
    const message = isAdd ? ADD_BOOKMARK_JOB_SUCCESS : REMOVE_BOOKMARK_JOB_SUCCESS;

    const myJobsFieldNames = [
        'active',
        'activeDt',
        'city',
        'cityLocation',
        'comingSoon',
        'country',
        'createDt',
        'currency',
        'currencySymbol',
        'education',
        'employerId',
        'employmentType',
        'filled',
        'esId', // injected below
        'intern',
        'isEmpBadge',
        'isExactRate',
        'jobApplicationUrl',
        'jobDescription',
        'jobTitle',
        'note',
        'otherEducation',
        'parentId', // injected below
        'payFrequency',
        'rateMax',
        'rateMin',
        'state',
        'statusDt',
        'telework',
        'yrsOfExp',
        'uid', // need this for CollectionGroup
        'updateDt',
    ];

    const myJobsEmployerFieldNames = ['companyName', 'companyProfilePicUrl', 'isEmpBadge', 'benefitSummary', 'companyBio'];

    //-------------------------------------------------------------------------------------------
    // prep for jobs
    //-------------------------------------------------------------------------------------------
    const jobRef = db.collection('jobs').doc(jobId);
    let jsSavedJobDto = null;
    let myJobsDto = null;

    //-------------------------------------------------------------------------------------------
    // prep for users
    //-------------------------------------------------------------------------------------------
    const userRef = db.collection('users').doc(userId);
    let userDto = null;
    userDto = { bookmarkedJobs: isAdd ? getArrayUnion(jobId) : getArrayRemove(jobId) };

    //-------------------------------------------------------------------------------------------
    // prep for myJobs
    //-------------------------------------------------------------------------------------------
    const myJobRef = db.collection('myJobs').doc(userId);

    //-------------------------------------------------------------------------------------------
    // prep for myJobs jsSavedJobs
    //-------------------------------------------------------------------------------------------
    const myJobJsSavedJobRef = db.collection('myJobs').doc(userId).collection('jsSavedJobs').doc(jobId);

    //-------------------------------------------------------------------------------------------
    // prep for myJobs appliedJobs
    //-------------------------------------------------------------------------------------------
    // const myJobAppliedJobRef = db.collection('myJobs').doc(userId).collection('appliedJobs').doc(jobId);

    try {
        // This code may get re-run multiple times if there are conflicts.
        await db.runTransaction(async transaction => {
            //-------------------------------------------------------------------------------------------
            // read myJobs
            //-------------------------------------------------------------------------------------------
            // const myJobDoc = await transaction.get(myJobRef);
            // const myJobData = myJobDoc.data();

            //-------------------------------------------------------------------------------------------
            // read myJobs jsSavedJobs
            //-------------------------------------------------------------------------------------------
            const myJobJsSavedJobDoc = await transaction.get(myJobJsSavedJobRef);
            const esId = _get(myJobJsSavedJobDoc.data(), 'esId', nanoid());

            //-------------------------------------------------------------------------------------------
            // read myJobs appliedJobs
            //-------------------------------------------------------------------------------------------
            // const myJobAppliedJobDoc = await transaction.get(myJobAppliedJobRef);
            // const myJobAppliedJobData = myJobAppliedJobDoc.data();
            // const applyDt = _get(myJobAppliedJobData, `jobs.${jobId}.applyDt`);

            //-------------------------------------------------------------------------------------------
            // read jobs
            //-------------------------------------------------------------------------------------------
            if (isAdd) {
                const jobDoc = await transaction.get(jobRef);
                const jobData = jobDoc.data();

                jsSavedJobDto = _pick({ ...jobData, uid: jobId, parentId: userId, esId }, myJobsFieldNames); // copy only certain fields according to data model

                const employerId = _get(jobData, 'employerId');
                myJobsDto = { employers: { [employerId]: _pick(jobData, myJobsEmployerFieldNames) } };
            }

            //-------------------------------------------------------------------------------------------
            // write myJobs
            //-------------------------------------------------------------------------------------------
            if (isAdd) {
                await transaction.set(myJobRef, mapDefinedFields(myJobsDto), { merge: true });
            }

            //-------------------------------------------------------------------------------------------
            // write myJobs jsSavedJobs
            //-------------------------------------------------------------------------------------------
            if (isAdd) {
                await transaction.set(myJobJsSavedJobRef, mapDefinedFields(jsSavedJobDto), { merge: true });
                // } else if (_isNil(applyDt)) {
            } else {
                // remove only if the job has not been applied
                await transaction.delete(myJobJsSavedJobRef);
            }

            //-------------------------------------------------------------------------------------------
            // write users
            //-------------------------------------------------------------------------------------------
            await userRef.update(userDto);
        });

        setSnackbarMessage(message);

        return true;
    } catch (error) {
        console.log('error', error);
        setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        return false;
    }
};

export const loadRecentSearches = ({ userId, setData }) => {
    const db = getFirestore();

    const jobCenterRef = db.collection('jobCenters').doc(userId);
    let recentSearches = [];

    return jobCenterRef.onSnapshot(doc => {
        if (doc.exists) {
            const data = doc.data();
            recentSearches = _get(data, 'recentSearches', []);
        }
        setData(recentSearches);
    });
};

export const updateRecentSearches = async ({ userId, recentSearches = [] }) => {
    const db = getFirestore();

    const jobCenterRef = db.collection('jobCenters').doc(userId);
    jobCenterRef.set({ recentSearches }, { merge: true });
};

//--------------------------------------------------------------------------
// Job Title Suggestion
//--------------------------------------------------------------------------
export const getJobTitleSuggestions = async ({ keywords, esToken, setEsToken }) => {
    // const db = getFirestore();

    let checkedEsToken = null;
    try {
        checkedEsToken = await checkEsToken(esToken);
    } catch (error) {
        console.log('Failed checking token', error);
    }

    try {
        if (checkedEsToken) {
            const esResp = await elasticSearchJobTitleSkillSetSuggestionSearchPostFetch({
                queryObject: { jobTitle: keywords },
                token: checkedEsToken.token,
            });

            if (checkedEsToken.isNew) {
                setEsToken(_omit(checkedEsToken, 'isNew'));
            }

            const result = _get(esResp, 'result', []);
            // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> ', { result });

            // return _map(result, item => ({ label: item?.jobTitle, value: item?.jobTitle }));
            return _map(result, item => item?.jobTitle);
        }

        return [];
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};

//--------------------------------------------------------------------------
// Location Suggestion
// Result sample:
// {
//     "code": "string",
//     "country": "string",
//     "currency": "string",
//     "id": "string",
//     "location": {
//       "lat": 0,
//       "lon": 0
//     },
//     "name": "string",
//     "native": "string",
//     "phoneCode": "string",
//     "state": "string",
//     "type": "CITY"
// }
//--------------------------------------------------------------------------
export const getLocationSuggestions = async ({ keywords, esToken, setEsToken }) => {
    // const db = getFirestore();

    let checkedEsToken = null;
    try {
        checkedEsToken = await checkEsToken(esToken);
    } catch (error) {
        console.log('Failed checking token', error);
    }

    try {
        if (checkedEsToken) {
            const esResp = await getElasticSearchLocationSuggestionPostFetch({
                queryObject: { name: keywords },
                token: checkedEsToken.token,
            });

            if (checkedEsToken.isNew) {
                setEsToken(_omit(checkedEsToken, 'isNew'));
            }

            const result = _get(esResp, 'result', []);
            // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> ', { result });

            // return _map(result, item => ({ label: item?.jobTitle, value: item?.jobTitle }));
            return _map(result, item => {
                const { country, state, name, type } = item;
                switch (type) {
                    case ELASTICSEARCH_TYPE_COUNTRY: {
                        return { label: name, value: item };
                    }
                    case ELASTICSEARCH_TYPE_STATE: {
                        return { label: `${name}, ${country}`, value: item };
                    }
                    case ELASTICSEARCH_TYPE_CITY: {
                        return { label: `${name}, ${state}, ${country}`, value: item };
                    }
                    default:
                    // do nothing
                }
            });
        }

        return [];
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};
